import { data } from 'jquery';
import React from 'react'

const reservedWords =['-',','] // => replace word to _

export function reservedWordCheck(name){
  return name.replace(/-|,/g, "_")
}

// --------------------------- date zone -------------------------------------//
export const today = new Date();

export const year = today.getFullYear();
export const yyyy = year.toString();

export const month = (today.getMonth()+1<10 ? '0' : '')+(today.getMonth()+1);
export const mm = month.toString();

export const day = (today.getDate()<10 ? '0' : '')+today.getDate();
export const dd = day.toString();

export const zeroHHMM = ' 00:00'
export const fullHHMM = ' 23:59'

export const viewDateFormat = (date, zeroTime) => {
  if (zeroTime) {
    return date.substr(0,4) + '/' + date.substr(5,2) + '/' + date.substr(8,2) + zeroHHMM;
  }
  else {
    return date.substr(0,4) + '/' + date.substr(5,2) + '/' + date.substr(8,2)
  }
}

export const apiDateFormat = (date) =>{
  return date.substr(0,4) + date.substr(5,2) + date.substr(8,2) +zeroHHMM+':00'
}

export const yminusone = (year-1).toString();
export const currentHHMM = ' ' + today.getHours() +':' + today.getMinutes();
export const currentDate = yyyy + '/' + mm + '/' + dd + fullHHMM;
export const currentDateTime = yyyy + '/' + mm + '/' + dd + currentHHMM;
export const lastOne =  viewDateFormat((new Date(new Date().getTime()-(1*24*60*60*1000))).toISOString().slice(0, 10), false);
export const lastSeven = viewDateFormat((new Date(new Date().getTime()-(7*24*60*60*1000))).toISOString().slice(0, 10), true);
export const lastThrity = viewDateFormat((new Date(new Date().getTime()-(30*24*60*60*1000))).toISOString().slice(0, 10), true);
export const lastSixty = viewDateFormat((new Date(new Date().getTime()-(60*24*60*60*1000))).toISOString().slice(0, 10), true);
export const lastNinety = viewDateFormat((new Date(new Date().getTime()-(90*24*60*60*1000))).toISOString().slice(0, 10), true);
export const lastYear = yminusone + '/' + mm + '/' + dd + zeroHHMM;

//----------------------------------------------------------------------------//

export const spinner = <div className="lds-ripple"><div></div><div></div></div>;



export const moment = require('moment');
moment.locale('zh-tw', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsParseExact : true,
    weekdays : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    weekdaysParseExact : true,
});

require('moment/locale/zh-tw');

export function timeStateFormater(timeState){
  let time = ''
  switch (timeState) {
    case '過去24小時':
      time = lastOne
      break;
    case '過去7天':
      time = lastSeven
      break
    case '過去30天':
      time = lastThrity
      break
    case '過去60天':
      time = lastSixty
      break
    case '過去90天':
      time = lastNinety
      break
    case '過去1年':
      time = lastYear
      break
    default:
      break;
  }
  return apiDateFormat(time)
}

export const twentyfiveColor = ['#C5C6C7', '#1C53AD', '#2259B0', '#285FB4', '#2D65B7', '#336BBB', '#3970BF', '#3F76C2', '#457CC6', '#4A82C9', '#5088CD', '#568ED1', '#5C93D4', '#6299D8', '#679FDB', '#6DA5DF', '#73ABE2', '#79B1E6', '#192033', '#7FB6EA', '#84BCED', '#8AC2F1', '#90C8F4', '#96CEF8', '#9CD4FC'];
export const basicColor = ['#ffea96', '#4dbd74', '#f86c6b', '#63c2de'];
export const blueShades = ['rgb(10, 67, 116)', 'rgb(44, 148, 236)', 'rgb(161, 208, 247)', 'rgb(15, 95, 163)', 'rgb(114, 183, 242)', 'rgb(19, 122, 209)', 'rgb(68, 160, 238)'];
export const outsideColors = ['#4dbd74', '#f86c6b','#63c2de'];
export const comparisonColors = ['#17a2b8', '#4dbd74', '#f86c6b', '#ffea96', 'rgb(10, 67, 116)', '#264653', '#2A9D8F', '#E9C46A', '#F4A261', '#E76F51', '#FFCAD4', '#9D8189'];
export const fiveInterval = [
  '#f8cb00', '#e6b72a', '#e0be5a', '#e6cf8b', '#cba847',
  '#20a8d8', '#37a4cb', '#5caecb', '#78b1c5', '#a8cbd7',
  '#e83e8c', '#d96098', '#db8db1', '#dbb1c4', '#aa2c65',
  '#20c997', '#0abb70', '#25b276', '#53b251', '#92cf90',
  '#9c27b0', '#ab47bc', '#ba68c8', '#ce93d8', '#e1bee7',
  '#360c0c', '#662121', '#893c3c', '#914f4f', '#914f4f',
  '#fbb5af', '#fcc1bc', '#fccdc9', '#fddad7', '#fee6e4'
]


// WEBPACK FOOTER //
// ./src/helpers/general.js